import { render, staticRenderFns } from "./assignform.vue?vue&type=template&id=d77e97c0&scoped=true&"
import script from "./assignform.vue?vue&type=script&lang=js&"
export * from "./assignform.vue?vue&type=script&lang=js&"
import style0 from "./assignform.vue?vue&type=style&index=0&id=d77e97c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d77e97c0",
  null
  
)

export default component.exports